import i18n from '../app/i18n';
import { SnackBarType } from '../app/types';
import { enqueueSnackbar } from './notifierSlice';

const errorHandle = error => async (dispatch, getStore) => {
  const { provider } = getStore().superMarket.EC;
  const errorMsg = error.response?.data?.error || error?.message || error;
  switch (errorMsg) {
    case 'server-error':
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`error-server-error`),
        }),
      );
      break;
    case 'invalid-session-token':
    case 'token-expired':
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`error-jwt-expired`),
        }),
      );
      break;
    case 'ga4Error':
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`ga4Error`),
        }),
      );
      break;
    case 'enabledECSettingError':
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`enabledECSettingError`, {
            provider: i18n.t(`ec.${provider}`),
          }),
        }),
      );
      break;
    case 'platformError':
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`platformError`),
        }),
      );
      break;
    case 'data-error-date':
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`data-error-date`),
        }),
      );
      break;
    case 'data-error':
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`data-error`),
        }),
      );
      break;
    case 'invalid-limits-message':
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`error-invalid-limits-message`),
        }),
      );
      break;
    case 'data-error-need-message':
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`data-error-need-message`),
        }),
      );
      break;
    default:
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: errorMsg,
        }),
      );
      break;
  }
};

export default errorHandle;
